export function filterDefaults(spec) {
  const values = {};
  (spec.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}

export function stageStyle(spec) {
  const canvas = spec.canvas || {};
  return {
    background: canvas.background || 'transparent',
    padding: (Number(canvas.padding) || 0) + 'px',
  };
}

export function pageScope(spec, placement, host, filters, local) {
  const declared = Object.keys(spec.implicit || {});
  const pageFilters = (spec.filters || []).map((f) => f.name);
  const ownFilters = (placement.filters || []).map((f) => f.name);
  const filled = (v) => v !== null && v !== undefined && v !== '';
  const scope = {};
  Object.entries(spec.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(host || {}).forEach(([k, v]) => { if (declared.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(filters || {}).forEach(([k, v]) => { if (pageFilters.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(placement.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(local || {}).forEach(([k, v]) => { if (ownFilters.includes(k) && filled(v)) scope[k] = v; });
  const chosen = [...(spec.filters || []), ...(placement.filters || [])]
    .filter((f) => f.type === 'entities')
    .map((f) => scope[f.name])
    .find((v) => v && !v.my_practices && (v.entity_ids || []).length === 1);
  if (chosen && !filled(scope.entity)) scope.entity = chosen.entity_ids[0];
  return scope;
}

export function localDefaults(placement) {
  const values = {};
  (placement.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}
